export enum CalculationType{
    Multiple = 0,
    Divide = 1
  }